import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountInfoService } from '~core/modules/identity/services/account-info.service';
import { switchMap, take, tap } from 'rxjs/operators';
import { CookieService } from '~shared/services/cookie.service';
import {
  SEARCH_API_CUSTOM_HEADER_URLS,
  HEADER_KEY_MM_ACCOUNT_ID,
  HEADER_KEY_GA_CLIENT_ID,
  HEADER_KEY_OPTIMIZELY_USER_ID,
  HEADER_KEY_EXPONEA_COOKIE
} from '~app/modules/catalog/constants/catalog-http-header.constant';
import { IAccountInformation } from '~shared/models';
import { getCookie } from "~shared/utils/cookie.util";
import { EXPONEA_COOKIE } from "~shared/constants";

@Injectable()
export class CatalogInterceptor implements HttpInterceptor {

  constructor(private readonly accountInfoService: AccountInfoService,
              private readonly cookieService: CookieService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isSearchUrl(request.url)) {
      return next.handle(request);
    }

    const userId = this.cookieService.getUserId();
    const optimizelyUserId = this.cookieService.getOptimizelyUserId();
    const exponeaCookie = getCookie(EXPONEA_COOKIE);

    return this.accountInfoService.getAccountInfo().pipe(
      take(1),
      switchMap((userData: IAccountInformation) => {
        if (!userData && !userId && !optimizelyUserId) {
          return next.handle(request);
        }

        const headers = {
          ...(userData ? {[HEADER_KEY_MM_ACCOUNT_ID]: userData.id} : {}),
          ...(userId ? {[HEADER_KEY_GA_CLIENT_ID]: userId} : {}),
          ...(optimizelyUserId ? {[HEADER_KEY_OPTIMIZELY_USER_ID]: optimizelyUserId} : {}),
          ...(this.shouldAddExponeaCookieHeader(request.url) && exponeaCookie ?
            {[HEADER_KEY_EXPONEA_COOKIE]: exponeaCookie}
            : {})
        };

        return next.handle(request.clone({
          setHeaders: headers
        }));
      })
    );
  }

  isSearchUrl(requestUrl): boolean {
    return SEARCH_API_CUSTOM_HEADER_URLS().some(urls => requestUrl.startsWith(urls));
  }

  shouldAddExponeaCookieHeader(requestUrl): boolean {
    return requestUrl.includes('/api/v3/recommendations/')
  }
}
